import _toConsumableArray from "/root/workspace/__flow_work/__flow_builds/9861699c-84a1-47cb-99a1-a59de1c49b16/workspace/streffy-middle-office_pMRG/node_modules/@babel/runtime-corejs2/helpers/esm/toConsumableArray.js";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.find-index";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.array.find";
import "core-js/modules/es6.array.map";
import "core-js/modules/es6.array.filter";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/9861699c-84a1-47cb-99a1-a59de1c49b16/workspace/streffy-middle-office_pMRG/node_modules/@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "@babel/runtime-corejs2/regenerator";
/**
 * 多标签页
 * */
import { get, cloneDeep } from 'lodash';
import router from '@/router';
import Setting from '@/setting';
import menuSider from '@/menu/sider';
import { getAllSiderMenu, includeArray } from '@/libs/system';

// 判定是否需要缓存
var isKeepAlive = function isKeepAlive(data) {
  return get(data, 'meta.cache', false);
};
export default {
  namespaced: true,
  state: {
    // 可以在多页 tab 模式下显示的页面
    pool: [],
    // 当前显示的多页面列表
    opened: Setting.page.opened,
    // 当前页面
    current: '',
    // 需要缓存的页面 name
    keepAlive: [],
    // 页面是否在编辑 后面路由守卫弹窗提示
    isEditing: false
  },
  actions: {
    /**
     * @description 从持久化数据载入分页列表
     */
    openedLoad: function openedLoad(_ref, _ref2) {
      var state = _ref.state,
        commit = _ref.commit,
        dispatch = _ref.dispatch,
        rootState = _ref.rootState;
      var _ref2$loadOpenedTabs = _ref2.loadOpenedTabs,
        loadOpenedTabs = _ref2$loadOpenedTabs === void 0 ? true : _ref2$loadOpenedTabs;
      return new Promise(/*#__PURE__*/function () {
        var _ref3 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee(resolve) {
          var value, valid;
          return _regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return dispatch('admin/db/get', {
                  dbName: 'streffy',
                  path: 'page.opened',
                  defaultValue: Setting.page.opened,
                  user: true
                }, {
                  root: true
                });
              case 2:
                value = _context.sent;
                if (!loadOpenedTabs) value = [];
                // 在处理函数中进行数据优化 过滤掉现在已经失效的页签或者已经改变了信息的页签
                // 以 fullPath 字段为准
                // 如果页面过多的话可能需要优化算法
                // valid 有效列表 1, 1, 0, 1 => 有效, 有效, 失效, 有效
                valid = []; // 处理数据
                state.opened = value.map(function (opened) {
                  // 忽略首页
                  if (opened.fullPath === '/index') {
                    valid.push(1);
                    return opened;
                  }
                  // 尝试在所有的支持多标签页的页面里找到 name 匹配的页面
                  var find = state.pool.find(function (item) {
                    return item.name === opened.name;
                  });
                  // 2.3.0 如果 value 项有 keepMeta 字段，则保留 meta
                  if (opened.keepMeta) {
                    find.meta = Object.assign({}, opened.meta);
                  }
                  // 记录有效或无效信息
                  valid.push(find ? 1 : 0);
                  // 返回合并后的数据 新的覆盖旧的
                  // 新的数据中一般不会携带 params 和 query, 所以旧的参数会留存
                  return Object.assign({}, opened, find);
                }).filter(function (opened, index) {
                  return valid[index] === 1;
                })
                // 对 menu 鉴权过滤
                .filter(function (opened) {
                  var allSiderMenu = getAllSiderMenu(menuSider);
                  var find = allSiderMenu.find(function (item) {
                    return item.path === opened.fullPath;
                  });
                  var state = true;
                  if (find && find.auth) {
                    var userInfo = rootState.admin.user.info;
                    // @权限
                    var access = cloneDeep(userInfo.access);
                    // 给 access 强制加一个 hidden 的权限，否则菜单隐藏后，Tabs 页签会不显示该页签
                    access.push('hidden');
                    // 如果用户当前的权限，不是该 menu 对应的 权限，则过滤这个 Tab
                    if (access && !includeArray(find.auth, access)) state = false;
                  }
                  return state;
                });
                // 根据 opened 数据生成缓存设置
                commit('keepAliveRefresh');
                // end
                resolve();
              case 8:
              case "end":
                return _context.stop();
            }
          }, _callee);
        }));
        return function (_x) {
          return _ref3.apply(this, arguments);
        };
      }());
    },
    /**
     * 将 opened 属性赋值并持久化 在这之前请先确保已经更新了 state.opened
     */
    opened2db: function opened2db(_ref4) {
      var state = _ref4.state,
        dispatch = _ref4.dispatch;
      return new Promise(/*#__PURE__*/function () {
        var _ref5 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee2(resolve) {
          return _regeneratorRuntime.wrap(function _callee2$(_context2) {
            while (1) switch (_context2.prev = _context2.next) {
              case 0:
                // 设置数据
                dispatch('admin/db/set', {
                  dbName: 'streffy',
                  path: 'page.opened',
                  value: state.opened,
                  user: true
                }, {
                  root: true
                });
                // end
                resolve();
              case 2:
              case "end":
                return _context2.stop();
            }
          }, _callee2);
        }));
        return function (_x2) {
          return _ref5.apply(this, arguments);
        };
      }());
    },
    /**
     * @description 更新页面列表上的某一项
     * @param {Object} param { index, params, query, fullPath } 路由信息
     */
    openedUpdate: function openedUpdate(_ref6, _ref7) {
      var state = _ref6.state,
        commit = _ref6.commit,
        dispatch = _ref6.dispatch;
      var index = _ref7.index,
        params = _ref7.params,
        query = _ref7.query,
        fullPath = _ref7.fullPath,
        meta = _ref7.meta,
        _ref7$keepMeta = _ref7.keepMeta,
        keepMeta = _ref7$keepMeta === void 0 ? false : _ref7$keepMeta;
      return new Promise(/*#__PURE__*/function () {
        var _ref8 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee3(resolve) {
          var page;
          return _regeneratorRuntime.wrap(function _callee3$(_context3) {
            while (1) switch (_context3.prev = _context3.next) {
              case 0:
                // 更新页面列表某一项
                page = state.opened[index];
                page.params = params || page.params;
                page.query = query || page.query;
                page.fullPath = fullPath || page.fullPath;
                page.meta = meta || page.meta;
                page.keepMeta = keepMeta;
                state.opened.splice(index, 1, page);
                // 持久化
                _context3.next = 9;
                return dispatch('opened2db');
              case 9:
                // end
                resolve();
              case 10:
              case "end":
                return _context3.stop();
            }
          }, _callee3);
        }));
        return function (_x3) {
          return _ref8.apply(this, arguments);
        };
      }());
    },
    /**
     * @description 更新页面当前项
     * @param {Object} param { params, query, fullPath } 路由信息
     */
    currentUpdate: function currentUpdate(_ref9, _ref0) {
      var state = _ref9.state,
        commit = _ref9.commit,
        dispatch = _ref9.dispatch;
      var params = _ref0.params,
        query = _ref0.query,
        fullPath = _ref0.fullPath,
        meta = _ref0.meta,
        _ref0$keepMeta = _ref0.keepMeta,
        keepMeta = _ref0$keepMeta === void 0 ? false : _ref0$keepMeta;
      return new Promise(/*#__PURE__*/function () {
        var _ref1 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee5(resolve) {
          return _regeneratorRuntime.wrap(function _callee5$(_context5) {
            while (1) switch (_context5.prev = _context5.next) {
              case 0:
                setTimeout(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
                  var index, page;
                  return _regeneratorRuntime.wrap(function _callee4$(_context4) {
                    while (1) switch (_context4.prev = _context4.next) {
                      case 0:
                        // 更新当前项
                        index = state.opened.findIndex(function (item) {
                          return item.fullPath === state.current;
                        });
                        page = state.opened[index];
                        page.params = params || page.params;
                        page.query = query || page.query;
                        page.fullPath = fullPath || page.fullPath;
                        page.meta = meta || page.meta;
                        page.keepMeta = keepMeta;
                        state.opened.splice(index, 1, page);
                        // 持久化
                        _context4.next = 10;
                        return dispatch('opened2db');
                      case 10:
                        // end
                        resolve();
                      case 11:
                      case "end":
                        return _context4.stop();
                    }
                  }, _callee4);
                })), 0);
              case 1:
              case "end":
                return _context5.stop();
            }
          }, _callee5);
        }));
        return function (_x4) {
          return _ref1.apply(this, arguments);
        };
      }());
    },
    /**
     * @description 新增一个 tag (打开一个页面)
     * @param {Object} param new tag info
     */
    add: function add(_ref11, _ref12) {
      var state = _ref11.state,
        commit = _ref11.commit,
        dispatch = _ref11.dispatch;
      var tag = _ref12.tag,
        params = _ref12.params,
        query = _ref12.query,
        fullPath = _ref12.fullPath;
      return new Promise(/*#__PURE__*/function () {
        var _ref13 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee6(resolve) {
          var newTag;
          return _regeneratorRuntime.wrap(function _callee6$(_context6) {
            while (1) switch (_context6.prev = _context6.next) {
              case 0:
                // 设置新的 tag 在新打开一个以前没打开过的页面时使用
                newTag = tag;
                newTag.params = params || newTag.params;
                newTag.query = query || newTag.query;
                newTag.fullPath = fullPath || newTag.fullPath;
                // 添加进当前显示的页面数组
                state.opened.push(newTag);
                // 如果这个页面需要缓存 将其添加到缓存设置
                if (isKeepAlive(newTag)) {
                  commit('keepAlivePush', tag.name);
                }
                // 持久化
                _context6.next = 8;
                return dispatch('opened2db');
              case 8:
                // end
                resolve();
              case 9:
              case "end":
                return _context6.stop();
            }
          }, _callee6);
        }));
        return function (_x5) {
          return _ref13.apply(this, arguments);
        };
      }());
    },
    /**
     * @description 打开一个新的页面
     * @param {Object} param 从路由钩子的 to 对象上获取 { name, params, query, fullPath } 路由信息
     */
    open: function open(_ref14, _ref15) {
      var state = _ref14.state,
        commit = _ref14.commit,
        dispatch = _ref14.dispatch;
      var name = _ref15.name,
        params = _ref15.params,
        query = _ref15.query,
        fullPath = _ref15.fullPath;
      return new Promise(/*#__PURE__*/function () {
        var _ref16 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee7(resolve) {
          var opened, pageOpenedIndex, pageOpened, page;
          return _regeneratorRuntime.wrap(function _callee7$(_context7) {
            while (1) switch (_context7.prev = _context7.next) {
              case 0:
                // 已经打开的页面
                opened = state.opened; // 判断此页面是否已经打开 并且记录位置
                pageOpenedIndex = 0;
                pageOpened = opened.find(function (page, index) {
                  var same = page.fullPath === fullPath;
                  pageOpenedIndex = same ? index : pageOpenedIndex;
                  return same;
                });
                if (!pageOpened) {
                  _context7.next = 8;
                  break;
                }
                _context7.next = 6;
                return dispatch('openedUpdate', {
                  index: pageOpenedIndex,
                  params: params,
                  query: query,
                  fullPath: fullPath
                });
              case 6:
                _context7.next = 12;
                break;
              case 8:
                // 页面以前没有打开过
                page = state.pool.find(function (t) {
                  return t.name === name;
                }); // 如果这里没有找到 page 代表这个路由虽然在框架内 但是不参与标签页显示
                if (!page) {
                  _context7.next = 12;
                  break;
                }
                _context7.next = 12;
                return dispatch('add', {
                  tag: Object.assign({}, page),
                  params: params,
                  query: query,
                  fullPath: fullPath
                });
              case 12:
                commit('currentSet', fullPath);
                // end
                resolve();
              case 14:
              case "end":
                return _context7.stop();
            }
          }, _callee7);
        }));
        return function (_x6) {
          return _ref16.apply(this, arguments);
        };
      }());
    },
    /**
     * @description 关闭一个 tag (关闭一个页面)
     * @param {Object} param { tagName: 要关闭的标签名字 }
     */
    close: function close(_ref17, _ref18) {
      var state = _ref17.state,
        commit = _ref17.commit,
        dispatch = _ref17.dispatch;
      var tagName = _ref18.tagName;
      return new Promise(/*#__PURE__*/function () {
        var _ref19 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee8(resolve) {
          var newPage, isCurrent, len, i, index, _newPage, _newPage$name, name, _newPage$params, params, _newPage$query, query, routerObj;
          return _regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) switch (_context8.prev = _context8.next) {
              case 0:
                // 下个新的页面
                newPage = state.opened[0];
                isCurrent = state.current === tagName; // 如果关闭的页面就是当前显示的页面
                if (!isCurrent) {
                  _context8.next = 12;
                  break;
                }
                // 去找一个新的页面
                len = state.opened.length;
                i = 0;
              case 5:
                if (!(i < len)) {
                  _context8.next = 12;
                  break;
                }
                if (!(state.opened[i].fullPath === tagName)) {
                  _context8.next = 9;
                  break;
                }
                // 是否只剩最后一个，是则跳首页
                if (len > 1) {
                  // 如果是最后一个，则向前一个跳，否则向下一个跳
                  if (i === len - 1) {
                    newPage = state.opened[i - 1];
                  } else {
                    newPage = state.opened[i + 1];
                  }
                } else {
                  newPage = {};
                }
                return _context8.abrupt("break", 12);
              case 9:
                i++;
                _context8.next = 5;
                break;
              case 12:
                // 找到这个页面在已经打开的数据里是第几个
                index = state.opened.findIndex(function (page) {
                  return page.fullPath === tagName;
                });
                if (index >= 0) {
                  // 如果这个页面是缓存的页面 将其在缓存设置中删除
                  commit('keepAliveRemove', state.opened[index].name);
                  // 更新数据 删除关闭的页面
                  state.opened.splice(index, 1);
                }
                // 持久化
                _context8.next = 16;
                return dispatch('opened2db');
              case 16:
                // 最后需要判断是否需要跳到首页
                if (isCurrent) {
                  _newPage = newPage, _newPage$name = _newPage.name, name = _newPage$name === void 0 ? 'index' : _newPage$name, _newPage$params = _newPage.params, params = _newPage$params === void 0 ? {} : _newPage$params, _newPage$query = _newPage.query, query = _newPage$query === void 0 ? {} : _newPage$query;
                  routerObj = {
                    name: name,
                    params: params,
                    query: query
                  };
                  router.push(routerObj, function () {});
                }
                // end
                resolve();
              case 18:
              case "end":
                return _context8.stop();
            }
          }, _callee8);
        }));
        return function (_x7) {
          return _ref19.apply(this, arguments);
        };
      }());
    },
    /**
     * @description 关闭当前标签左边的标签
     * @param {Object} param { pageSelect: 当前选中的tagName }
     */
    closeLeft: function closeLeft(_ref20) {
      var state = _ref20.state,
        commit = _ref20.commit,
        dispatch = _ref20.dispatch;
      var _ref21 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        pageSelect = _ref21.pageSelect;
      return new Promise(/*#__PURE__*/function () {
        var _ref22 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee9(resolve) {
          var pageAim, currentIndex;
          return _regeneratorRuntime.wrap(function _callee9$(_context9) {
            while (1) switch (_context9.prev = _context9.next) {
              case 0:
                pageAim = pageSelect || state.current;
                currentIndex = 0;
                state.opened.forEach(function (page, index) {
                  if (page.fullPath === pageAim) {
                    currentIndex = index;
                  }
                });
                if (currentIndex > 0) {
                  // 删除打开的页面 并在缓存设置中删除
                  state.opened.splice(1, currentIndex - 1).forEach(function (_ref23) {
                    var name = _ref23.name;
                    return commit('keepAliveRemove', name);
                  });
                }
                state.current = pageAim;
                if (router.app.$route.fullPath !== pageAim) {
                  router.push(pageAim);
                }
                // 持久化
                _context9.next = 8;
                return dispatch('opened2db');
              case 8:
                // end
                resolve();
              case 9:
              case "end":
                return _context9.stop();
            }
          }, _callee9);
        }));
        return function (_x8) {
          return _ref22.apply(this, arguments);
        };
      }());
    },
    /**
     * @description 关闭当前标签右边的标签
     * @param {Object} param { pageSelect: 当前选中的tagName }
     */
    closeRight: function closeRight(_ref24) {
      var state = _ref24.state,
        commit = _ref24.commit,
        dispatch = _ref24.dispatch;
      var _ref25 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        pageSelect = _ref25.pageSelect;
      return new Promise(/*#__PURE__*/function () {
        var _ref26 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee0(resolve) {
          var pageAim, currentIndex;
          return _regeneratorRuntime.wrap(function _callee0$(_context0) {
            while (1) switch (_context0.prev = _context0.next) {
              case 0:
                pageAim = pageSelect || state.current;
                currentIndex = 0;
                state.opened.forEach(function (page, index) {
                  if (page.fullPath === pageAim) {
                    currentIndex = index;
                  }
                });
                // 删除打开的页面 并在缓存设置中删除
                state.opened.splice(currentIndex + 1).forEach(function (_ref27) {
                  var name = _ref27.name;
                  return commit('keepAliveRemove', name);
                });
                // 设置当前的页面
                state.current = pageAim;
                if (router.app.$route.fullPath !== pageAim) {
                  router.push(pageAim);
                }
                // 持久化
                _context0.next = 8;
                return dispatch('opened2db');
              case 8:
                // end
                resolve();
              case 9:
              case "end":
                return _context0.stop();
            }
          }, _callee0);
        }));
        return function (_x9) {
          return _ref26.apply(this, arguments);
        };
      }());
    },
    /**
     * @description 关闭当前激活之外的 tag
     * @param {Object} param { pageSelect: 当前选中的tagName }
     */
    closeOther: function closeOther(_ref28) {
      var state = _ref28.state,
        commit = _ref28.commit,
        dispatch = _ref28.dispatch;
      var _ref29 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
        pageSelect = _ref29.pageSelect;
      return new Promise(/*#__PURE__*/function () {
        var _ref30 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee1(resolve) {
          var pageAim, currentIndex;
          return _regeneratorRuntime.wrap(function _callee1$(_context1) {
            while (1) switch (_context1.prev = _context1.next) {
              case 0:
                pageAim = pageSelect || state.current;
                currentIndex = 0;
                state.opened.forEach(function (page, index) {
                  if (page.fullPath === pageAim) {
                    currentIndex = index;
                  }
                });
                // 删除打开的页面数据 并更新缓存设置
                if (currentIndex === 0) {
                  state.opened.splice(1).forEach(function (_ref31) {
                    var name = _ref31.name;
                    return commit('keepAliveRemove', name);
                  });
                } else {
                  state.opened.splice(currentIndex + 1).forEach(function (_ref32) {
                    var name = _ref32.name;
                    return commit('keepAliveRemove', name);
                  });
                  state.opened.splice(1, currentIndex - 1).forEach(function (_ref33) {
                    var name = _ref33.name;
                    return commit('keepAliveRemove', name);
                  });
                }
                // 设置新的页面
                state.current = pageAim;
                if (router.app.$route.fullPath !== pageAim) {
                  router.push(pageAim);
                }
                // 持久化
                _context1.next = 8;
                return dispatch('opened2db');
              case 8:
                // end
                resolve();
              case 9:
              case "end":
                return _context1.stop();
            }
          }, _callee1);
        }));
        return function (_x0) {
          return _ref30.apply(this, arguments);
        };
      }());
    },
    /**
     * @description 关闭所有 tag
     * @param {Object} state vuex state
     */
    closeAll: function closeAll(_ref34) {
      var state = _ref34.state,
        commit = _ref34.commit,
        dispatch = _ref34.dispatch;
      return new Promise(/*#__PURE__*/function () {
        var _ref35 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee10(resolve) {
          return _regeneratorRuntime.wrap(function _callee10$(_context10) {
            while (1) switch (_context10.prev = _context10.next) {
              case 0:
                // 删除打开的页面 并在缓存设置中删除
                state.opened.splice(1).forEach(function (_ref36) {
                  var name = _ref36.name;
                  return commit('keepAliveRemove', name);
                });
                // 持久化
                _context10.next = 3;
                return dispatch('opened2db');
              case 3:
                // 关闭所有的标签页后需要判断一次现在是不是在首页
                if (router.app.$route.name !== 'index') {
                  router.push({
                    name: 'index'
                  }, function () {});
                }
                // end
                resolve();
              case 5:
              case "end":
                return _context10.stop();
            }
          }, _callee10);
        }));
        return function (_x1) {
          return _ref35.apply(this, arguments);
        };
      }());
    },
    /**
     * @description 直接更新 opened，用于拖拽调整页签顺序
     * */
    updateOpened: function updateOpened(_ref37, _ref38) {
      var state = _ref37.state,
        commit = _ref37.commit,
        dispatch = _ref37.dispatch;
      var opened = _ref38.opened;
      return new Promise(/*#__PURE__*/function () {
        var _ref39 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee11(resolve) {
          return _regeneratorRuntime.wrap(function _callee11$(_context11) {
            while (1) switch (_context11.prev = _context11.next) {
              case 0:
                state.opened = opened;
                // 持久化
                _context11.next = 3;
                return dispatch('opened2db');
              case 3:
                // end
                resolve();
              case 4:
              case "end":
                return _context11.stop();
            }
          }, _callee11);
        }));
        return function (_x10) {
          return _ref39.apply(this, arguments);
        };
      }());
    },
    updatePool: function updatePool(_ref40, _ref41) {
      var commit = _ref40.commit;
      var routes = _ref41.routes;
      return new Promise(/*#__PURE__*/function () {
        var _ref42 = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime.mark(function _callee12(resolve) {
          return _regeneratorRuntime.wrap(function _callee12$(_context12) {
            while (1) switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return commit('init', routes);
              case 2:
                // end
                resolve();
              case 3:
              case "end":
                return _context12.stop();
            }
          }, _callee12);
        }));
        return function (_x11) {
          return _ref42.apply(this, arguments);
        };
      }());
    }
  },
  mutations: {
    /**
     * @class keepAlive
     * @description 从已经打开的页面记录中更新需要缓存的页面记录
     * @param {Object} state vuex state
     */
    keepAliveRefresh: function keepAliveRefresh(state) {
      state.keepAlive = state.opened.filter(function (item) {
        return isKeepAlive(item);
      }).map(function (e) {
        return e.name;
      });
    },
    /**
     * @description 删除一个页面的缓存设置
     * @param {Object} state vuex state
     * @param {String} name name
     */
    keepAliveRemove: function keepAliveRemove(state, name) {
      var list = _toConsumableArray(state.keepAlive);
      var index = list.findIndex(function (item) {
        return item === name;
      });
      if (index !== -1) {
        list.splice(index, 1);
        state.keepAlive = list;
      }
    },
    /**
     * @description 增加一个页面的缓存设置
     * @param {Object} state vuex state
     * @param {String} name name
     */
    keepAlivePush: function keepAlivePush(state, name) {
      var keep = _toConsumableArray(state.keepAlive);
      keep.push(name);
      state.keepAlive = keep;
    },
    /**
     * @description 清空页面缓存设置
     * @param {Object} state vuex state
     */
    keepAliveClean: function keepAliveClean(state) {
      state.keepAlive = [];
    },
    /**
     * @class current
     * @description 设置当前激活的页面 fullPath
     * @param {Object} state vuex state
     * @param {String} fullPath new fullPath
     */
    currentSet: function currentSet(state, fullPath) {
      state.current = fullPath;
    },
    /**
     * @class pool
     * @description 保存 pool (候选池)
     * @param {Object} state vuex state
     * @param {Array} routes routes
     */
    init: function init(state, routes) {
      var pool = [];
      var _push = function push(routes) {
        routes.forEach(function (route) {
          if (route.children) {
            _push(route.children);
          } else {
            if (!route.hidden) {
              var meta = route.meta,
                name = route.name,
                path = route.path;
              pool.push({
                meta: meta,
                name: name,
                path: path
              });
            }
          }
        });
      };
      _push(routes);
      state.pool = pool;
    },
    // 定义修改 isEditing 状态的 mutation
    setEditing: function setEditing(state, isEditing) {
      state.isEditing = isEditing;
    }
  }
};